<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>文件创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="backFn"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->

      <el-form
        :model="formData"
        :rules="rules"
        label-width="110px"
        ref="formData"
      >
        <el-form-item label="上传类型" required>
          <el-radio-group v-model="fileType" size="small">
            <el-radio :label="1" border>附件</el-radio>
            <el-radio :label="2" border>富文本</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传附件" required v-if="fileType == 1">
          <el-upload
            class="upload-demo"
            action="https://jsonplaceholder.typicode.com/posts/"
            multiple
            :on-change="handleChange"
            :on-remove="handleRemove"
            :http-request="uploadFn"
            :on-exceed="handleExceed"
            :limit="1"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div> -->
          </el-upload>
        </el-form-item>
        <el-form-item label="培训内容" required v-if="fileType == 2">
          <MyEditor ref="editor" />
        </el-form-item>
        <!-- <el-form-item label="讲解人" prop="explainer">
          <el-input v-model="formData.explainer"></el-input>
        </el-form-item> -->

        <el-form-item label="备注" prop="remark">
          <el-input v-model="formData.remark"></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status" size="small">
            <el-radio :label="1" border>启用</el-radio>
            <el-radio :label="2" border>禁用</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <!-- <el-form-item label="开始时间" prop="startDt">
          <el-date-picker
            v-model="formData.startDt"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endDt">
          <el-date-picker
            v-model="formData.endDt"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择结束时间"
          >
          </el-date-picker>
        </el-form-item> -->
        <!-- <el-form-item label="文件类型" prop="uploadType">
          <el-input
            v-model="formData.uploadType"
            placeholder="上传附件自动回填"
            disabled
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="文件地址" prop="uploadUrl">
          <el-input
            v-model="formData.uploadUrl"
            placeholder="上传附件自动回填"
            disabled
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="文件名称" prop="uploadName">
          <el-input
            v-model="formData.uploadName"
            placeholder="上传附件自动回填"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="文件大小" prop="fileSize">
          <el-input
            v-model="formData.fileSize"
            placeholder="上传附件自动回填"
            disabled
          ></el-input>
        </el-form-item> -->
        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>创建</span>
          </el-button>
          <!-- <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="clearFn"
          >
            <span>重置</span>
          </el-button> -->
        </div>
      </el-form>

      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addFile, uploadFile } from '@/api/training'
import MyEditor from './components/MyEditor.vue'
export default {
  components: { MyEditor },
  data() {
    return {
      fileList: [],
      fileType: 1, //上传类型
      formData: {
        // explainer: '',
        status: 1,
        remark: '',

        uploadUrl: '',
        uploadName: '',
        uploadType: '',
        fileSize: '',
        // startDt: '',
        // endDt: '',
        trainId: ''
      },
      rules: {
        // upload: [{ required: true, message: '请上传文件', trigger: 'blur' }]
        // explainer: [{ required: true, message: '讲解人必填', trigger: 'blur' }]
      }
    }
  },
  created() {
    console.log(this.$route.query)
    this.formData.trainId = this.$route.query.id
  },
  methods: {
    uploadFn(parma) {
      console.log(parma.file)
      const formData = new FormData()
      formData.append('multipartFile', parma.file) // 传入bpmn文件
      this.$loading({
        text: '文件上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.formData.fileSize = res.data.fileSize
          this.formData.uploadName = res.data.uploadName
          this.formData.uploadType = res.data.uploadType
          this.formData.uploadUrl = res.data.uploadUrl
          console.log(this.formData)
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.$loading().close()
        } else {
          this.fileList = []
          this.$message({
            message: '上传失败',
            type: 'success'
          })
          this.$loading().close()
        }
      })
      // setTimeout(() => {
      //   this.$loading().close()
      // }, 1500)
    },
    backFn() {
      this.$router.push({
        path: '/training/filelist',
        query: { id: this.formData.trainId }
      })
    },
    //移除文件
    handleRemove() {
      this.formData.fileSize = ''
      this.formData.uploadName = ''
      this.formData.uploadType = ''
      this.formData.uploadUrl = ''
    },
    //超限制
    handleExceed(files, fileList) {
      console.log(files, fileList)

      this.$message.warning('目前只能上传一个包')
    },
    handleChange(file) {
      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024)
      if (imgSize > 1000) {
        this.$msgbox({
          title: '',
          message: '文件大小不能超过1000MB，请重新上传。',
          type: 'warning'
        })
        this.fileList = []
        return
      }
    },
    // 判断富文本编辑器输入是否为空或回车
    getText(str) {
      return str
        .replace(/<[^<p>]+>/g, '') // 将所有<p>标签 replace ''
        .replace(/<[</p>$]+>/g, '') // 将所有</p>标签 replace ''
        .replace(/&nbsp;/gi, '') // 将所有 空格 replace ''
        .replace(/<[^<br/>]+>/g, '') // 将所有 换行符 replace ''
    },
    isNull(str) {
      if (str == '') return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    // 重置
    clearFn() {
      this.$refs.formData.resetFields()
    },
    // 创建
    submitFn() {
      // 富文本类型
      if (this.fileType == 2) {
        this.formData.fileSize = ''
        this.formData.uploadName = '富文本'
        this.formData.uploadType = 'edit' //富文本编辑
        this.formData.uploadUrl = this.$refs.editor.html
        let text = this.getText(this.$refs.editor.html)
        let validateValue = this.isNull(text)
        console.log(this.isNull(text)) // true表示判空  false表示不为空
        if (validateValue) {
          this.$message({
            message: '培训内容不能为空',
            type: 'error'
          })
          return
        }
      }
      if (this.fileType == 1) {
        if (this.formData.uploadUrl == '') {
          this.$message.error('至少上传一个附件！')
          return
        }
      }

      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          console.log(this.formData, '文件创建')
          if (this.submited) return
          this.$loading({
            text: '文件添加中'
          })
          // let infos = JSON.parse(JSON.stringify(this.formData))

          // if (!this.formData.status) {
          //   this.formData.status = 1
          // }
          console.log(this.formData)
          addFile(this.formData).then((res) => {
            console.log(res.data, '创建')
            if (res.code == 200) {
              this.submited = true
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
          })
          this.$loading().close()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// .create {
//   .button-group {
//     display: flex;
//     justify-content: center;
//     .form-button {
//       margin: 0 20px;
//     }
//   }
// }
</style>
